.searchResults {
  .searchResultsHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }

  .title {
    font: var(--font-heading-xs-bold);
    color: var(--primitives-colors-neutral-0);
    text-transform: capitalize;
  }

  .searchResultsList {
    margin: 0 -24px;

    .phone &,
    .tablet & {
      margin: 0 -16px;
    }
  }

  .clearAllBtn {
    all: unset;
    color: var(--semantic-colors-typography-faded);
    font: var(--font-body-sm-medium);
    cursor: pointer;
    text-decoration: underline;
  }
}